var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"menu",staticClass:"graph_card",attrs:{"id":"graph_context_menu"}},_vm._l((_vm.menu_options),function(option,i){return _c('div',{key:i,on:{"click":function($event){return _vm.execute(option.target)}}},[_c('GraphIcon',{attrs:{"icon":option.icon}}),_c('span',[_vm._v(_vm._s(option.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }